import React from 'react';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';

function PlanItem({ t, labelKey, value: count }) {
  return (
    <li>
      <Trans i18nKey={`plan.attributes.${labelKey}`} count={count} values={{ count }}>
        <strong>
          {count}
        </strong>
        of this.
      </Trans>
    </li>
  );
}

PlanItem.propTypes = {
  t: PropTypes.func.isRequired,
  labelKey: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};

export default PlanItem;



// WEBPACK FOOTER //
// ./src/app/components/PlanModal/components/PlanItem/index.js